import _keyBy from 'lodash/keyBy';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_LOAD_SITE_BANNERS_EXCHANGE__REQUEST,
  ACTION_LOAD_SITE_BANNERS_EXCHANGE__SUCCESS,
  ACTION_LOAD_SITE_BANNERS_EXCHANGE__FAIL,
} from '../actionTypes';

import { actionAddBanners } from './banners';


export const actionLoadSiteBannersExchangeSuccess = (siteId, mappedBannerIds) => ({
  type: ACTION_LOAD_SITE_BANNERS_EXCHANGE__SUCCESS,
  payload: { siteId, mappedBannerIds },
});

export const actionLoadSiteBannersExchangeFail = error => ({
  type: ACTION_LOAD_SITE_BANNERS_EXCHANGE__FAIL,
  payload: { error },
});

export const actionLoadSiteBannersExchangeRequest = siteId => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_SITE_BANNERS_EXCHANGE__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/site_banner/exchange',
      { params: { siteId } }
    ).then(
      ({ availableBanners, mappedBannerIds }) => {
        dispatch(actionAddBanners(_keyBy(availableBanners, 'id')));
        dispatch(actionLoadSiteBannersExchangeSuccess(siteId, mappedBannerIds));
      },
      error => {
        dispatch(actionLoadSiteBannersExchangeFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
